import {
  REQUEST_DASHBOARD_DATA_SUCCESS,
  REQUEST_FETCH_HEALTH_DATA_SUCCESS,
  REQUEST_FETCH_HEALTH_DATA_FAILURE,
  REQUEST_FETCH_HEALTH_DATA_START,
  REQUEST_RECENT_POSTS_SUCCESS,
  REQUEST_RECENT_POSTS_FAILURE,
  REQUEST_RECENT_POSTS_START
} from '../constants/actionTypes';

const INITIAL_STATE = { data: {}, errors: null, isLoading: false, healthData: [], isLoadingRecentPosts: true };

export default function dashboardData(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_DASHBOARD_DATA_SUCCESS:
      return { ...state, data: action.payload.data, errors: null }
    case REQUEST_FETCH_HEALTH_DATA_START:
      return { ...state, isLoading: true, healthData: [] }
    case REQUEST_FETCH_HEALTH_DATA_SUCCESS:
      return { ...state, isLoading: false, healthData: action.payload }
    case REQUEST_FETCH_HEALTH_DATA_FAILURE:
      return { ...state, isLoading: false }
    case REQUEST_RECENT_POSTS_SUCCESS:
      return { ...state, recentPosts: action.payload, isLoadingRecentPosts: false }
    case REQUEST_RECENT_POSTS_START:
      return { ...state, recentPosts: action.payload, isLoadingRecentPosts: true }
      case REQUEST_RECENT_POSTS_FAILURE:
        return {...state, isLoadingRecentPosts: false}
    default:
      return state;
  }
}